<template>
  <span v-if="show" class="animated fadeIn" :class="`text-${variant}`"><i class="fa animated pulse" :class="icon"></i> {{message}}</span>
</template>

<script>
import alertMixin from './alert-mixin'

export default {
  mixins: [alertMixin]
}
</script>



// WEBPACK FOOTER //
// TextAlert.vue?4dc15e14